module.exports = __webpack_public_path__ + "static/media/sign2.ade2c214.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/sign2.PNG
// module id = 541
// module chunks = 0